import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');
    if (!token) {
        console.log("No token found, redirecting to login..."); 
        return <Navigate to="/TGSH/login" replace />;
    }
    return children;
};

export default ProtectedRoute;